
import { useI18n } from "src/utils/lni18n";
import { GroupedStudentClasses } from "../domain/CourseEditModel";
import { StudentClassGroupsTable } from "src/components/StudentClassGroups/StudentClassGroupsTable";

export const AffectedClassesList: React.FC<{ classes: GroupedStudentClasses }> = ({
    classes
}) => {

    const { languageService: t } = useI18n();

    const head = (
        <thead>
            <tr>
                <th>
                    {t.getText("name")}
                </th>

                <th>
                    {t.getText("mainteacher")}
                </th>
                <th>
                    {t.getText("startdate")}
                </th>
                <th>
                    {t.getText("enddate")}
                </th>

                <th>
                    {t.getText("unit")}
                </th>
            </tr>
        </thead>
    );

    return (

        <StudentClassGroupsTable classes={classes} columns={5} head={head} row={cl => <>
            <td>
                {cl.Name}
            </td>
            <td>
                {cl.MainTeacher?.FirstName} {cl.MainTeacher?.LastName}
            </td>
            <td className="white-space-nowrap">
                {t.getShortDateString(cl.StartDate)}
            </td>
            <td className="white-space-nowrap">
                {t.getShortDateString(cl.ClassEndDate)}
            </td>
            <td className="white-space-nowrap">
                {cl.UnitName}
            </td>
        </>} />


    )
}
